import React from "react";
import {observer} from "mobx-react-lite";
import {MultiSelect} from "primereact/multiselect";

import appStore from "../storage/AppStore";
import systemStore from "../storage/SystemStore";

import "../common/multiselect.css";


const MultipleSelect = ({
    value,
    store,
    prop,

    options = [],

    label,
    placeholder,

    optionLabel = "name",
    optionValue = "id",

    itemTemplate,

    display = "comma",
    maxSelectedLabels = 5,
    selectedItemsLabel,

    required = false,
    invalid: invalidProp,

    disabled = false,

    full = true,
    small = false,

    className = "",

    onChange,

    ...rest
}) => {

    const storeBound =
        store !== undefined &&
        prop !== undefined;


    const currentValue =
        value !== undefined
            ? value
            : storeBound
                ? store[prop]
                : [];


    const selectedValues =
        Array.isArray(currentValue)
            ? currentValue
            : [];


    const invalid =
        invalidProp ??
        (
            required &&
            storeBound &&
            Boolean(store?.was_validated) &&
            selectedValues.length === 0
        );


    const isDisabled =
        disabled ||
        systemStore.loading;


    const rootClassName = [
        full && "w-full",
        small && "p-inputtext-sm",
        invalid && "multi_invalid",
        className,
    ]
        .filter(Boolean)
        .join(" ");


    const defaultItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                {option?.icon && (
                    <span>
                        {option.icon}
                    </span>
                )}

                <span>
                    {option?.[optionLabel]}
                </span>
            </div>
        );
    };


    const handleChange = (event) => {
        const nextValue =
            Array.isArray(event.value)
                ? event.value
                : [];


        if (storeBound) {
            store.setProperty(
                prop,
                nextValue
            );
        }


        onChange?.(
            nextValue,
            event
        );
    };


    return (
        <MultiSelect
            {...rest}

            value={selectedValues}
            options={options}

            optionLabel={optionLabel}
            optionValue={optionValue}

            placeholder={
                placeholder ??
                label
            }

            display={display}

            maxSelectedLabels={
                maxSelectedLabels
            }

            selectedItemsLabel={
                selectedItemsLabel ??
                appStore.tr.all
            }

            itemTemplate={
                itemTemplate ??
                defaultItemTemplate
            }

            disabled={isDisabled}

            invalid={invalid}

            className={rootClassName}

            onChange={handleChange}
        />
    );
};


export default observer(MultipleSelect);